import React, { useEffect, useState } from "react";
import { ChatMain } from "./components/ChatMain";
import InvalidSummaryMessage from "./components/UI/InvalidSummaryMessage";

import useSessionStore from "./context/useSessionStore";
import { Alert, AlertColor, styled } from "@mui/material";
import "./styles/embedded.scss";
import { MainLoader } from "./components/UI/MainLoader";

const MessageBox = styled(Alert)({
  width: "calc(100% - 8px)",
  position: "absolute",
  bottom: 4,
  left: 2,
  alignSelf: "center",
  "&:dir(rtl)": {
    "& .MuiAlert-icon": {
      marginLeft: 12,
      marginRight: 0,
    },
    "& .MuiAlert-action": {
      marginRight: "auto",
      marginLeft: -8,
    },
  },
});
//endregion [[ Styles ]]

//region [[ Props ]]

export interface EmbeddedChatProps {
  loading: boolean;
}
//endregion [[ Props ]]

//region [[ Functions ]]

//endregion [[ Functions ]]

export const EmbeddedChat = ({ loading }: EmbeddedChatProps) => {
  const {
    mainMessage,
    loadingRagSettings,
    loadingChatSession,
    patientSummary,
  } = useSessionStore();

  const [message, setMessage] = useState<{
    severity: AlertColor;
    text: string;
  }>(null);
  const [loadingSession, setLoadingSession] = useState(true);
  const [invalidCase, setInvalidCase] = useState(false);

  useEffect(() => {
    setLoadingSession(loadingRagSettings || loadingChatSession || loading);
  }, [loadingRagSettings, loadingChatSession, loading]);

  useEffect(() => {
    setInvalidCase(!patientSummary || !patientSummary.valid);
  }, [patientSummary]);

  useEffect(() => {
    if (mainMessage) {
      setMessage(mainMessage);
    }
  }, [mainMessage]);

  return (
    <>
      {loadingSession ? (
        <MainLoader title={"Loading Dialogue"} />
      ) : invalidCase ? (
        <InvalidSummaryMessage />
      ) : (
        <ChatMain />
      )}
      {message && (
        <MessageBox
          severity={message.severity}
          variant={"filled"}
          onClose={() => setMessage(null)}
        >
          {message.text}
        </MessageBox>
      )}
    </>
  );
};
